import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	status: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	pageSize: 5,
	status: null,
};

const portalProjects = createSlice({
	name: 'portalProjects',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStatus: (state, action: PayloadAction<{ status: string | null }>) => {
			state.status = action.payload.status;
			state.page = initialState.page;
		},
		resetPortalProjects: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setStatus,
	resetPortalProjects,
} = portalProjects.actions;

export default portalProjects.reducer;
